import script from "./myClass.vue?vue&type=script&setup=true&lang=js"
export * from "./myClass.vue?vue&type=script&setup=true&lang=js"

import "./myClass.vue?vue&type=style&index=0&id=69e330c1&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e330c1"]])

export default __exports__